import React, { useRef, useEffect, useState,useCallback } from 'react';
import Header from "../components/Header";
import BottomNavBar from "../components/BottomNavBar";
import CounselorReviewDetails from '../components/CounselorReviewDetails';
import StudentReviewDetails from '../components/StudentReviewDetails';
import { useForm } from "react-hook-form";
import { useReactToPrint } from 'react-to-print';
import { LinkContainer } from "react-router-bootstrap";
import { Breadcrumb, Row, Col, Spinner } from 'react-bootstrap';
import { useParams, useSearchParams } from 'react-router-dom';
import * as studentDetailsAPI from "../services/studentEntries";
import toast, { toastConfig } from 'react-simple-toasts';
import { baseUrl } from '../utilities/config';

const StudentEntries = () => {
   
    const componentRef = useRef();
    const params = useParams();
    const [searchParams] = useSearchParams();

    const [details, setDetails] = useState('');
    const [studHCode, setHexCode] = useState('');
    const [loader, setLoader] = useState(false)

    toastConfig({
        render: message => <div 
        style={{ backgroundColor: '#cc2427', color: 'white', 
        padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    // let hexCode = "";

    useEffect(() => {
        
        document.title = 'Review | Families of WWII Veterans';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, [])
    useEffect(() => {
        let hexCode = searchParams.get("code")
        setHexCode(hexCode)
    }, [searchParams])
    

    const getReviewDetails = useCallback(async () => {
        setLoader(true)
        try {
            await studentDetailsAPI.getStudentEntriesDetails(`${studHCode}/student-entries`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    setDetails(res.data);
                } else {
                    if (res.status === 204) {
                        return
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            })
                .catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [studHCode])
    useEffect(() => {
        if(studHCode){
            getReviewDetails()
        } 
    }, [getReviewDetails,studHCode])
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const { handleSubmit } = useForm({
        defaultValues: {}
    });
    const onSubmit = data => {
        handlePrint()
    }
    return (
        <React.Fragment>
            <section ref={componentRef}>
                <Header title="Scholarship Applications" />
                {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                    <Spinner animation="border" variant="primary" /> </div>}
                <div className="container pt-5" >
                    <div className="row">
                        <div className="col-12 ">
                            <nav>
                                <Breadcrumb>
                                    <LinkContainer to={"/student-entries-home/"}>
                                        <Breadcrumb.Item className={"breadCrumbItemCompleted"}>
                                            <span>Student Applications</span>
                                        </Breadcrumb.Item>
                                    </LinkContainer>
                                    <Breadcrumb.Item className={"breadCrumbItemActive"} active={true}>
                                        <span>{params.studentName}</span>
                                    </Breadcrumb.Item>

                                </Breadcrumb>
                            </nav>

                            {details &&
                                <StudentReviewDetails
                                    details={details[0]}
                                    hrTag="hide"
                                />}
                            <h3><strong>Documents Uploaded</strong></h3>
                            <Row className="mb-3">
                                <Col lg={6}>
                                    <h4 className="h6">Letter of recommendation:</h4>
                                    <p>
                                        {details &&
                                            <a href={`${baseUrl}files?studentCode=${details[0].studentCode}&fileType=LORFile`} download>Download</a>
                                        }
                                    </p>
                                </Col>
                                <Col lg={6}>
                                    <h4 className="h6">Transcript or proof of enrollment:</h4>
                                    <p>
                                        {details &&
                                             <a href={`${baseUrl}files?studentCode=${details[0].studentCode}&fileType=PORFile`} download>Download</a>
                                        }
                                    </p>
                                </Col>
                                <Col lg={6}>
                                    <h4 className="h6">W2 form or previous year's household tax return:</h4>
                                    <p>
                                        {details &&
                                           
                                            <a href={`${baseUrl}files?studentCode=${details[0].studentCode}&fileType=TRFile`} download>Download</a>
                                        }
                                    </p>

                                </Col>
                                <Col lg={6}>
                                    <h4 className="h6">500 word essay on how WWII affected your life:</h4>
                                    <p>
                                        {details &&
                                            <a href={`${baseUrl}files?studentCode=${details[0].studentCode}&fileType=ESFile`} download>Download</a>
                                        }
                                    </p>
                                </Col>
                            </Row>
                            <hr />

                            <h2 className="text-primary">Counselor/Advisor</h2>
                            {details &&
                                <CounselorReviewDetails
                                    counRevDetails={details[0].counselorRating}
                                />}


                            <form onSubmit={handleSubmit(onSubmit)}>
                                <BottomNavBar submitButtonTitle="PRINT" />
                            </form>

                        </div>
                    </div>
                </div>
            </section>

        </React.Fragment>

    );
}

export default StudentEntries;